export default __webpack_public_path__ + "static/media/Star.67075bc2.svg";